// import api from "../api/axiosInstance";

// // user login
// export const login = async (email, password) => {
//   try {
//     const res = await api.post("/auth/login", { email, password });
//     return res.data;
//   } catch (error) {
//     throw error;
//   }
// };

// // user registration
// export const register = async (username, email, password) => {
//   try {
//     const res = await api.post("/auth/register", { username, email, password });
//     return res.data;
//   } catch (error) {
//     throw error;
//   }
// };

// //get current user details
// export const getCurrentUser = async () => {
//   try {
//     const userId = JSON.parse(localStorage.getItem("user"))?.id;
//     const res = await api.get(`/users/${userId}`);
//     return res.data;
//   } catch (error) {
//     throw error;
//   }
// };

// // user logout
// export const logout = () => {
//   localStorage.clear();
// };
import api from "../api/axiosInstance";

// ✅ LOGIN
export const login = async (email, password) => {
  try {
    const res = await api.post("/auth/login", { email, password });

    // ✅ store token + user
    localStorage.setItem("token", res.data.token);
    localStorage.setItem("user", JSON.stringify(res.data.user));

    return res.data;
  } catch (error) {
    throw error;
  }
};

// ✅ REGISTER (FIXED FIELD NAME)
export const register = async (
  username,
  email,
  password,
  phone,
  profession,
  professionDetails,
) => {
  try {
    const res = await api.post("/auth/register", {
      userName: username, // 🔥 IMPORTANT FIX
      email,
      password,
      phone,
      profession,
      professionDetails,
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};

// ✅ GET CURRENT USER
export const getCurrentUser = async () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.id) throw new Error("User not found");

    const res = await api.get(`/profiles/user/${user.id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// ✅ LOGOUT
export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

//update user password
export const updatePassword = async (currentPassword, newPassword) => {
  try {
    const res = await api.post("/auth/change-password", {
      currentPassword,
      newPassword,
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

//forgotpassword send otp to email
export const forgotPassword = async (email) => {
  try {
    const res = await api.post("/auth/send-otp", { email });
    return res.data;
  } catch (error) {
    throw error;
  }
};

//verify otp
export const verifyOtp = async (email, otp) => {
  try {
    const res = await api.post("/auth/verify-otp", { email, otp });
    return res.data;
  } catch (error) {
    throw error;
  }
};

//reset password
export const resetPassword = async (newPassword, resetToken) => {
  try {
    const res = await api.post(
      "/auth/reset-password",
      { newPassword },
      {
        headers: {
          Authorization: `Bearer ${resetToken}`,
        },
      },
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
